
























import moment from 'moment';
import Vue from 'vue';
import { fetchConfiguracionStreamax } from './../fetchConfiguracionStreamax';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import Confirmation from '@/components/Confirmation.vue'; //
import { TranslateResult } from 'vue-i18n';
import { GridApi } from 'ag-grid-community';
import { consoleSandbox } from '@sentry/utils';
import { asociacionEventBus } from '@/setup';
import FormGeneralRecordStreamax from './FormGeneralRecordStreamax.vue';
import FormMainStreamRecordStreamax from './FormMainStreamRecordStreamax.vue';
import FormDualStreamRecordStreamax from './FormDualStreamRecordStreamax.vue';
import FormNetStreamRecordStreamax from './FormNetStreamRecordStreamax.vue';
@Component({
  components: {
    'app-confirmacion': Confirmation,
    FormGeneralRecordStreamax,
    FormMainStreamRecordStreamax,
    FormDualStreamRecordStreamax,
    FormNetStreamRecordStreamax,
  },
})
export default class RecordStreamax extends Vue {
  @Prop({ default: false }) edited!: any;
  @Prop({ default: false }) esEdicion!: boolean;
  @Prop({ default: {} }) selectedValue: any;
  @Prop({ default: {} }) usuario: any;
  show: boolean = true;
  accion!: any;
  ordesList2: any;
  items: any[] = [
    { index: 0, tab: 'General', content: 'FormGeneralRecordStreamax' },
    { index: 1, tab: 'Main Stream', content: 'FormMainStreamRecordStreamax' },
    { index: 2, tab: 'Dual Stream', content: 'FormDualStreamRecordStreamax' },
    { index: 3, tab: 'Net Stream', content: 'FormNetStreamRecordStreamax' },
  ];
  tab: any = null;
  mounted(): void {
    console.log(this.usuario);
  }
}
